import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidatePassword } from "@insite/client-framework/Store/CommonHandlers/ValidatePassword";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";

const regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$^!*#()\/\[\]{}/_/;.,-])[A-Za-z\d@$^!*#()\/\[\]{}/_/;.,-]{0,}$/;
// /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$^!*&#()\\\/\[\]{}/_/;/./,-])[A-Za-z\d@$^!*&#()\\\/\[\]{}/_/;/./,-]{0,}$/;
// /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^@$!*#()\\\/\[\]{}/_/;/./,-])[A-Za-z\d^@$!*#()\\\/\[\]{}/_/;/./,-]{8,}$/;

// const regExp =
//     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^@$!*#()\\\/\[\]{}/_/;/./,-])[A-Za-z\d^@$!*#()\\\/\[\]{}/_/;/./,-]{8,}$/;

replaceInChain(chain, ValidatePassword, props => {
    let errorMessage: React.ReactNode = "";
    const password = props.parameter.password;
    const {
        passwordMinimumLength,
        passwordRequiresDigit,
        passwordRequiresLowercase,
        passwordRequiresUppercase,
        passwordRequiresSpecialCharacter,
    } = getSettingsCollection(props.getState()).accountSettings;

    if (!password) {
        errorMessage = siteMessage("CreateNewAccountInfo_Password_Required");
    } else if (!errorMessage && password.length > 0 && password.length < passwordMinimumLength) {
        errorMessage = translate("Password must be at least abc {0} characters long", passwordMinimumLength.toString());
    } else if (!errorMessage && passwordRequiresDigit && !regExp.test(password)) {
        errorMessage = translate(
            "Password must require 1 uppercase letter, 1 lowercase letter, 1 digit, 1 special character !@#$^*()-_;.,/{}[]",
        );
    }

    props.passwordErrorMessage = errorMessage;
});
